
import CloseIcon from '@mui/icons-material/Close';
import { Button, Dialog, DialogTitle, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function ModalVoucher({ voucherId, isOpen, setIsOpen }) {
  const { t } = useTranslation('app');
  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <IconButton onClick={() => setIsOpen(false)} style={{ cursor: 'pointer' }}>
          <CloseIcon />
        </IconButton>
      </div>
      <DialogTitle>
        {t('modalVoucher.message1')} {voucherId} {t('modalVoucher.message2')}
      </DialogTitle>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '16px',
          padding: '1rem 0',
        }}
      >
        <Button
          onClick={() => setIsOpen(false)}
          variant="contained"
          color="primary"
          style={{ fontWeight: '700' }}
        >
          {t('modalVoucher.close')}
        </Button>
      </div>
    </Dialog>
  );
}
